import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "header-menu" }
const _hoisted_2 = {
  key: 0,
  class: "header-menu__overlay"
}
const _hoisted_3 = { class: "header-menu__items" }

import ResizeObserver from 'resize-observer-polyfill';
import { computed, onBeforeUnmount, onMounted, provide, reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  props: {
  incomingWrapperStyles: { type: Object, default: () => {} },
  lightTheme: { type: Boolean, default: false },
  position: { type: String, default: 'right' },
},
  setup(__props) {

const props = __props;

const menuButton = ref<HTMLElement>();
const menuOpen = ref(false);
const state = reactive({
  buttonBounds: {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0,
  },
  documentSizes: {
    width: 0,
    height: 0,
  },
});

const getScrollAreaMaxHeight = (top: string, documentHeight: number) => `calc(${documentHeight}px - ${top})`;
const arrowOffset = {
  x: 18,
  y: 18,
};

const wrapperStyles = computed(() => {
  let position: Dictionary<string>;

  if (props.position === 'left') {
    position = {
      left: '0px',
    };
  } else {
    position = {
      right: '0px',
    };
  }

  return {
    top: `calc(${state.buttonBounds.height}px + 5px)`,
    ...position,
    ...props.incomingWrapperStyles,
  };
});

const scrollStyles = computed(() => ({ maxHeight: getScrollAreaMaxHeight(`${state.buttonBounds.bottom + arrowOffset.y}px`, state.documentSizes.height) }));

const computingSizes = (el: HTMLElement) => {
  state.buttonBounds = el.getBoundingClientRect();
  state.documentSizes.width = document.documentElement.clientWidth;
  state.documentSizes.height = document.documentElement.clientHeight;
};

const recalculate = () => {
  if (menuButton.value) {
    computingSizes(menuButton.value);
  }
};

const openMenu = () => {
  recalculate();
  menuOpen.value = !menuOpen.value;
};

const closeMenu = () => {
  menuOpen.value = false;
};

const bodyObserver = new ResizeObserver((entries: Array<ResizeObserverEntry>) => {
  entries.forEach(() => {
    recalculate();
  });
});

bodyObserver.observe(document.body);

provide('closeMenu', closeMenu);

onMounted(() => {
  recalculate();
});

onBeforeUnmount(() => {
  if (bodyObserver) {
    bodyObserver.disconnect();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ot_scroll = _resolveComponent("ot-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "menuButton",
      ref: menuButton,
      class: "header-menu__activator",
      onClick: openMenu
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (menuOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade-scale",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (menuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['header-menu__overlay', { 'header-menu__overlay--transparent': true }]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (closeMenu()), ["self"]))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade-scale",
      mode: "in-out"
    }, {
      default: _withCtx(() => [
        (menuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle(wrapperStyles.value),
              class: _normalizeClass(['xot-menu__wrapper', 'header-menu__wrapper', { open: menuOpen.value, [__props.position]: true, 'header-menu__wrapper--light': __props.lightTheme }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ot_scroll, {
                  class: "header-menu__scroll-area",
                  style: _normalizeStyle(scrollStyles.value)
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "menu-content", { closeMenu: closeMenu })
                  ]),
                  _: 3
                }, 8, ["style"])
              ])
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})